import { SxProps, Theme } from '@mui/material'

export const containerStyle: SxProps<Theme> = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
}
